// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__AUd0T"};